const ACCESS_TOKEN_KEY = 'yet2book.access_token';
const ADMIN_BACKUP_TOKEN_KEY = 'yet2book.admin_backup_token';

const read = key => {
  const value = localStorage.getItem(key);
  return typeof value === 'string' && value.trim() ? value : null;
};

export const getAccessToken = () => read(ACCESS_TOKEN_KEY);
export const setAccessToken = token => {
  if (typeof token === 'string' && token.trim()) localStorage.setItem(ACCESS_TOKEN_KEY, token);
  else localStorage.removeItem(ACCESS_TOKEN_KEY);
};
export const getAdminBackupToken = () => read(ADMIN_BACKUP_TOKEN_KEY);
export const setAdminBackupToken = token => {
  if (typeof token === 'string' && token.trim()) localStorage.setItem(ADMIN_BACKUP_TOKEN_KEY, token);
  else localStorage.removeItem(ADMIN_BACKUP_TOKEN_KEY);
};
export const clearAuthStorage = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(ADMIN_BACKUP_TOKEN_KEY);
};